import { render, staticRenderFns } from "./DepartmentTable.vue?vue&type=template&id=50f8ccaa&scoped=true"
import script from "./DepartmentTable.vue?vue&type=script&lang=js"
export * from "./DepartmentTable.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTable.vue?vue&type=style&index=0&id=50f8ccaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8ccaa",
  null
  
)

export default component.exports